// stores/campaignThemeStore.ts
import { makeAutoObservable } from "mobx";
import api, {
  GetCampaignThemeListParameters,
  GetCampaignThemeListRes,
  GetCampaignThemeParameters,
  GetCampaignThemeRes,
} from "../api";
import { createRequestStatus, handleRequest } from "../toll/toolRequestStatus";

class CampaignThemeStore {
  campaignThemeData: { [x: string]: GetCampaignThemeRes } = {}
  campaignThemeDataList?: GetCampaignThemeListRes;
  getCampaignThemeStatus = createRequestStatus();
  getCampaignThemeListStatus = createRequestStatus();

  constructor () {
    makeAutoObservable(this);
  }

  getCampaignThemeList = async (params: GetCampaignThemeListParameters) => {
    await handleRequest<GetCampaignThemeListRes>(
      this.getCampaignThemeListStatus,
      () => api.GetCampaignThemeList(params),
      (res) => {
        this.campaignThemeDataList = res
      },
      "获取活动主题失败"
    );
  };

  getCampaignTheme = async (params: GetCampaignThemeParameters) => {
    await handleRequest<GetCampaignThemeRes>(
      this.getCampaignThemeStatus,
      () => api.GetCampaignTheme(params),
      (res) => {
        this.campaignThemeData[params.id] = res
      },
      "获取活动主题失败"
    );
  };
}

const campaignThemeStore = new CampaignThemeStore();
export default campaignThemeStore;
